// extracted by mini-css-extract-plugin
export default {"rating":"zJ-z","numberOfStars":"AJ-z","count":"BJ-z","barGraphSpacing":"CJ-z","barGraph":"DJ-z"};